import React from 'react';
import format from 'date-fns/format'
import parse from 'date-fns/parse'
import parseJSON from 'date-fns/parseJSON'
import enGB from 'date-fns/locale/en-GB'
import fr from 'date-fns/locale/fr'
import enUS from 'date-fns/locale/en-US'
const locales = {'en-GB': enGB, 'fr-FR': fr, 'en-US': enUS, 'en': enGB, 'fr': fr}

const dateFormats = {
  fullMonthYear: 'MMMM yyyy',
  short: 'dd MMM yyyy',
  long: 'dd MMMM yyyy HH:mm:ss',
  longShortMonth: 'dd MMM yyyy HH:mm:ss'
}

function parseDateString(str) {
  if (str.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2} [\+-]{0,1}\d{4}/)) {
    return parse(str, 'yyyy-MM-dd HH:mm:ss xx', new Date())
  } else if (str.match(/^\d{4}-\d{2}-\d{2}$/)) {
    return parse(str, 'yyyy-MM-dd', new Date())
  } else {
    return parseJSON(str)
  }
}

function parseDate(date) {
  if (typeof(date) === 'number') {
    return new Date(date * 1000)
  } else if (typeof(date) === 'string'){
    return parseDateString(date)
  } else {
    return new Date(date)
  }
}

function formatDate(value, {dateFormat = 'short', defaultValue, i18n = {}} = {}) {
  if ( ! value ) { return defaultValue }
  return format(parseDate(value), dateFormats[dateFormat], {locale: locales[i18n.language]})
}

function FormattedDate({date, ...options}) {
  return <>{formatDate(date, options)}</>
}

function formatNumber(value, options = {}, i18n = {}) {
  const {digits = 0, defaultValue} = options
  const local = locales[i18n.language] ? locales[i18n.language] : 'en-US';
  if (typeof(value) === 'number') {
    return value.toLocaleString(local, {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits
    })
  } else if (typeof(value) === 'string') {
    return Number(value).toLocaleString(local, {
      maximumFractionDigits: digits,
      minimumFractionDigits: digits
    })
  } else {
    return defaultValue
  }
}

function FormattedNumber({value, ...options}) {
  if (typeof(value) === 'number') {
    return <>{formatNumber(value, options)}</>
  } else {
    return (null)
  }
}

function formatPercent(value, options) {
  return formatNumber(value, {digits: 1, ...options})+'%'
}

function FormattedPercent({value, options}) {
  if (typeof(value) === 'number') {
    return <>{formatPercent(value, options)}</>
  } else {
    return (null)
  }
}

function formatPrice(value, options) {
  return formatNumber(value, options)+' €'
}

function FormattedPrice({value, ...options}) {
  return <>{formatPrice(value, options)}</>
}

export { FormattedDate as Date };
export { FormattedNumber as Number };
export { FormattedPercent as Percent };
export { FormattedPrice as Price };
export { formatNumber, formatPercent, formatDate, formatPrice }
